export const environment = {
    production: false,
    api_configuracion: 'https://qa-emision-toks-nt-group-consulta-configuracion-a-6t3wt3vj6a-uc.a.run.app',
    api_busqueda_configuracion: 'https://qa-emision-toks-nt-group-con-autoportal-sucursal-980710815761.us-central1.run.app/api/v1/configuracion',
    api_autoportal: 'https://qa-emision-toks-nt-group-toks-api-autoportal-v2-980710815761.us-central1.run.app',
    api_archivos: 'https://qa-emision-toks-nt-group-archivos-980710815761.us-central1.run.app',
    api_mensajes_personalizados: 'https://qa-emision-toks-nt-group-mensajes-personalizados-980710815761.us-central1.run.app',
    apk: '5c535a72-84af-11ee-9281-6bebc8df1645',
    key_enc_url: 'fc713bf0-73a4-4f0a-87d4-1fded1c320a6'
};
